class MsxI10n {
  constructor() {
    this.labels = {};
    this.showMissingLabels = false;
  }

  init(dict) {
    this.labels = dict;
    try {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('showMissingLabels') === "true") {
        this.showMissingLabels = true;
      }
    } catch (error) {};

  }

  /**
   * Retrieve translation parameter
   * @param key
   * @param {'ui'|'data'} category
   * @param {object} options:
   *    - full: lookup the full key, don't construct from app name and category
   *    - raw: if missing, return undefined instead of a warning string
   * @return {*}
   */
  get(key, category = 'ui', options = {}) {
    if (key === undefined) {
      // eslint-disable-next-line no-console
      console.error('Trying to get an undefined key', key, category, options);
      return '?';
    }

    let _key = options.full ? key : `msx.${category}.${key.toLowerCase()}`;

    const label = this.labels[_key];
    if (label !== undefined) {
      return label.replace(/{{n}}/g, '\n');
    }

    return _key;
  }

  getOrDefault(key, defaultValue, category = 'ui', options = {}) {
    if (key === undefined) {
      // eslint-disable-next-line no-console
      console.error('Trying to get an undefined key', key, category, options);
      return defaultValue;
    }

    let _key = options.full ? key : `msx.${category}.${key.toLowerCase()}`;

    const label = this.labels[_key];

    let result = defaultValue || '';

    if (this.showMissingLabels && result?.length > 0) {
      result += ' MISSING LABEL ' + key;
    }

    if (label !== undefined) {
      result = label;
    }

    return result.replace(/{{n}}/g, '\n').replace(/{{t}}/g, '\t');
  }

  getAndReplace(key, data, category = 'ui', options = {}) {
    const label = this.get(key, category, options);
    return label.replace(/({.*})/gi, data);
  }

  getAndReplaceMultiple(key, datas, category = 'ui', options = {}) {
    let label = this.get(key, category, options);
    for (const data of datas) {
      label = label.replace(/({.*?})/, data);
    }
    return label;
  }
}

const I10n = new MsxI10n();
export default I10n;
